import React from "react";
import { PropertyEditorText, PropertyEditorTextInterface } from "../PropertyEditorText";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextData implements PropertyEditorTextInterface {
    editObject: object = {};
    hint: string = "hint";
    label: string = "TextEditor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
    requiredText: string = "required text";
}

let args = new TextData();

class TextData2 implements PropertyEditorTextInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "textValue"), new ValidationIssue("issue2", "textValue")];
        },
    };
    hint: string = "hint";
    label: string = "TextEditor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
    requiredText: string = "required text";
}

let args2 = new TextData2();
export const TextPropertyEditor = [
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorText
                    {...args}
                    onChange={() => {
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text",
        "Default",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorText
                    {...args}
                    error={"Error Text"}
                    onChange={() => {
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorText
                    {...args2}
                    onChange={() => {
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text",
        "Validation Provider",
    ),
];
